import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "services/baseQuery";

interface Client {
  client_id: string;
}

interface Webhook {
  client_id: string;
  webhook: string;
}

export const developers = createApi({
  reducerPath: "developers",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    clientApiKey: builder.mutation<any, Client>({
      query: (body) => ({
        url: `client/key`,
        method: "POST",
        body,
      }),
    }),
    updateWebhook: builder.mutation<any, Webhook>({
      query: (body) => ({
        url: `webhooks/store`,
        method: "POST",
        body,
      }),
    }),
    getClientKey: builder.query<any, void>({
      query: () => ({
        url: `client/key`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useClientApiKeyMutation,
  useGetClientKeyQuery,
  useUpdateWebhookMutation,
} = developers;
